/* MEATBROS · page d'accueil · vidéos d'ambiance (univers, bande culture)
   <video data-mbh-video autoplay muted loop playsinline> : lecture seulement quand la vidéo est visible,
   pause hors écran ou dans une section masquée, aucune lecture si le visiteur limite les animations
   (l'image placée dessous sert alors de repli). Vanilla, sans dépendance. */
(function () {
  'use strict';
  var reduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var calme = function () { return !!(reduit && reduit.matches); };

  function lire(v) {
    if (calme()) return;
    v.muted = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var observateur = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { lire(e.target); } else { e.target.pause(); }
    });
  }, { rootMargin: '150px 0px' }) : null;

  function init(racine) {
    var videos = (racine || document).querySelectorAll('video[data-mbh-video]');
    Array.prototype.forEach.call(videos, function (v) {
      if (v.getAttribute('data-mbh-pret')) return;
      v.setAttribute('data-mbh-pret', '1');
      v.muted = true;
      if (calme()) { v.removeAttribute('autoplay'); v.pause(); }
      if (observateur) observateur.observe(v);
    });
  }

  function surChangement() {
    Array.prototype.forEach.call(document.querySelectorAll('video[data-mbh-video]'), function (v) {
      if (calme()) { v.pause(); } else if (v.getClientRects().length) { lire(v); }
    });
  }

  init();
  if (reduit) {
    if (reduit.addEventListener) reduit.addEventListener('change', surChangement);
    else if (reduit.addListener) reduit.addListener(surChangement);
  }
  /* Éditeur de thème : section rechargée */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
